import { render, staticRenderFns } from "./CheckoutShipping.vue?vue&type=template&id=6897f326&"
import script from "./CheckoutShipping.vue?vue&type=script&lang=js&"
export * from "./CheckoutShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports